<div class="clipboard-container" *ngIf="clipboardService.clipboardData.value">
    {{(clipboardService.clipboardData.type === 'url') ? 'Link' : '"'+clipboardService.clipboardData.value+'"' }} copied
    to clipboard
</div>